
const aplicacionesStore = {
    namespaced: true,
    state: () => ({
        aplicacionesCliente: null,
        nombreNodo: null,
        idNodo: null,
        ultimoSeleccionado: false,
        informacionElemento: {
            nombre_asociado: null,
            id_asociado: null,
            etiqueta: null,
            fecha: null,
            tipo: null,
            id_sig_subobjeto: null,
            color: null,
        }
    }),
    mutations: {
        cambiarEtiqueta(state, payload) {
            if (state.informacionElemento.id_sig_subobjeto == payload.id_sig_subobjeto) {
                state.informacionElemento.etiqueta = payload.etiqueta;
            }
        },
        actualizarAplicaciones(state, payload) {
            state.aplicacionesCliente = payload.aplicacionesNodo;
            state.nombreNodo = payload.etiquetaNodo;
            state.idNodo = payload.idNodo;
            state.ultimoSeleccionado = true;
            state.informacionElemento.nombre_asociado = payload.nombre_asociado;
            state.informacionElemento.id_asociado = payload.id_asociado;
            state.informacionElemento.etiqueta = payload.etiqueta;
            state.informacionElemento.fecha = payload.fecha;
            state.informacionElemento.tipo = payload.tipo;
            state.informacionElemento.id_sig_subobjeto = payload.id_sig_subobjeto;
            state.informacionElemento.color = payload.color;
        },
        borrarAplicaciones(state) {
            state.aplicacionesCliente = null;
            state.nombreNodo = null;
            state.idNodo = null;
            state.informacionElemento.nombre_asociado = null;
            state.informacionElemento.id_asociado = null;
            state.informacionElemento.etiqueta = null;
            state.informacionElemento.fecha = null;
            state.informacionElemento.tipo = null;
            state.informacionElemento.id_sig_subobjeto = null;
            state.informacionElemento.color = null;
        }
    },
    actions: {
    },

    getters: {
        obtenerAplicaciones(state) {
            return state.aplicacionesCliente;
        }
    },
}

export default aplicacionesStore